import { NavLink, useLocation, useNavigate } from "react-router-dom"
import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { AREASLIST, AREASPROFILE } from "shared/consts/routingConsts"
import { useEffect } from "react"
import { getAreas } from "../api/getAreas"
import { HallsListWrapper } from "./style"

export const AreasTabs = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const { data } = useQuery({
        queryKey: ["getAreasList"], 
        queryFn: () => {
            return getAreas();
        },
        placeholderData: keepPreviousData,
        retry: 3,
    });

    useEffect(() => {
        if (data && data.areas.length > 0 && location.pathname === AREASLIST) {
            navigate(`${AREASPROFILE}/${data.areas[0].id}`);
        }
    }, [data, navigate, location.pathname]); 

    return (
        <>
            <HallsListWrapper>
                <div className="halls__list">
                    {data && data.areas.map((item, index) => {
                        const MAX_LENGTH = 10;
                        const truncatedName = item.name.length > MAX_LENGTH 
                            ? item.name.slice(0, MAX_LENGTH - 3) + "..." 
                            : item.name;

                        return (
                            <NavLink 
                                title={item.name} 
                                className="" 
                                key={index} 
                                to={`${AREASPROFILE}/${item.id}`}
                            >
                                {truncatedName}
                            </NavLink>
                        );
                    })}
                </div>
            </HallsListWrapper>
        </>
    )
}